export const getLottieAnimationJson = async (
  url: string,
  init?: RequestInit
): Promise<any> => {
  try {
    const response = await fetch(url, init)
    if (!response.ok) {
      throw new Error(`failed to get animation json file from: ${url}`)
    }
    const data = await response.json()
    if (data) return data
    return ''
  } catch (error) {
    if (error.name === 'AbortError') {
      // Request was cancelled by the client on unmount
      return
    }
    console.error('There was a problem with your fetch operation:', error)
    throw error
  }
}
